import React from "react";
import { Link } from "react-router-dom";
import { useSiteData, waLink } from "../../lib/hooks";
import { fileUrl } from "../../lib/api";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  const s = useSiteData();
  return (
    <footer className="relative bg-espresso text-ivory/80 grain overflow-hidden" data-testid="site-footer">
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-8 py-16 sm:py-24 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src={fileUrl(s.logo_url || "/logo.jpeg")} alt="Foodie Connect Caterer" className="h-20 rounded-md mb-5" />
          <p className="font-serif text-2xl leading-tight text-ivory">Offering Flavours</p>
          <p className="text-sm mt-3 leading-relaxed text-ivory/60 max-w-xs">
            Premium non-vegetarian catering crafted for celebrations, businesses and every occasion worth gathering for.
          </p>
        </div>

        <div>
          <p className="overline mb-5">Explore</p>
          <ul className="space-y-2.5 text-sm">
            {["About", "Our Menus", "Catering", "Experiences", "Corporate", "Gallery"].map((x) => (
              <li key={x}>
                <Link to={`/${x.toLowerCase().replace("our menus", "menus").replace(/ /g, "-")}`} className="hover:text-gold transition-colors">{x}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="overline mb-5">Reach Us</p>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-gold mt-0.5 shrink-0" />{s.address || "Hyderabad, India"}</li>
            <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-gold shrink-0" /><a href={`tel:${s.phone}`} className="hover:text-gold">{s.phone || "+91 93812 05545"}</a></li>
            <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-gold shrink-0" /><a href={`mailto:${s.email}`} className="hover:text-gold break-all">{s.email || "hello@foodieconnectcaterer.com"}</a></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-5">Let's Talk</p>
          <a href={waLink(s)} target="_blank" rel="noreferrer" className="btn-gold w-full justify-center mb-3" data-testid="footer-whatsapp">
            <i className="fa-brands fa-whatsapp" /> WHATSAPP US
          </a>
          <Link to="/contact" className="btn-outline-gold w-full justify-center" data-testid="footer-quote">REQUEST A QUOTE</Link>
          <div className="flex gap-4 mt-6 text-xl">
            <a href={s.socials?.instagram || "#"} target="_blank" rel="noreferrer" className="hover:text-gold"><i className="fa-brands fa-instagram" /></a>
            <a href={s.socials?.facebook || "#"} target="_blank" rel="noreferrer" className="hover:text-gold"><i className="fa-brands fa-facebook" /></a>
            <a href={s.socials?.youtube || "#"} target="_blank" rel="noreferrer" className="hover:text-gold"><i className="fa-brands fa-youtube" /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-gold/15">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-ivory/40">
          <p>© {new Date().getFullYear()} Foodie Connect Caterer. All rights reserved.</p>
          <p>Operations powered by <span className="text-gold/70">OPEREXA DINEOS</span> · <Link to="/admin" className="hover:text-gold">Staff Login</Link></p>
        </div>
      </div>
    </footer>
  );
}
